<template>
  <div class="my-auto mr-4">
    <EmployeeAttendanceExportControl
      @legend-clicked="showLegend"
      @print-clicked="printExport"
    ></EmployeeAttendanceExportControl>

    <b-sidebar
      id="test-sidebar"
      v-model="isSidebarOpen"
      right
      backdrop
      lazy
      sidebar-class="offcanvas"
      header-class="offcanvas-header d-flex mt-5 ml-5 mr-5"
      bg-variant="white"
    >
      <template v-slot:header-close>
        <button
          class="btn btn-sm btn-icon btn-light-secondary btn-hover-danger"
        >
          <i class="ki ki-close icon-xs"></i>
        </button>
      </template>

      <div class="d-flex mx-4 my-5 flex-grow-1">
        <EmployeeExportLegend
          :leaves="leaves"
          :aways="aways"
        ></EmployeeExportLegend>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import EmployeeAttendanceExportControl from "@/modules/company/components/attendance/export/EmployeeAttendanceExportControl";
import EmployeeExportLegend from "@/modules/company/components/shared/export/EmployeeExportLegend";
import { mapGetters } from "vuex";
export default {
  name: "EmployeeMonthlyExportControl",
  components: { EmployeeExportLegend, EmployeeAttendanceExportControl },
  data() {
    return {
      isSidebarOpen: false,
    };
  },
  methods: {
    showLegend() {
      this.isSidebarOpen = true;
    },
    printExport() {
      window.print();
    },
  },
  computed: {
    ...mapGetters({
      leaves: "getCompanyLeaveList",
      aways: "getCompanyAwayDetailList",
    }),
  },
};
</script>

<style scoped></style>
